// IMPORTS
import _ from 'lodash'
import axios from 'axios'
import mobiscroll from '@mobiscroll/javascript'

// DEFINITIONS
const loginApi = 'account/trylogin'

const state = {
	catalogo: []
}

const getters = {
    OfertaGetCatalogo: (state) => {
        return state.catalogo
    }
}

const mutations = {
	OfertaSetCatalogo: (state, payload) => {
        state.catalogo = payload
    }
}

const actions = {
	OfertasPublicasRefresh: async ({commit}) => {
        try {
            let response = await axios.get('catalogo/ofertaspublicas', { withCredentials: false })
            if(response.status){
                commit('OfertaSetCatalogo', response.data.ofertaspublicas)
            }
        } catch(e) {
            // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
            if (response.msg) {
                mobiscroll.snackbar({
                    display: 'top',
                    theme: 'ios',
                    message: response.msg,
                    color: response.class,
                    duration: 7000
                })
            }
        }
    }
}

// EXPORTS
export default {
	state,
	getters,
	mutations,
	actions
};